module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Regional-Landing-Page.05883c17.jpg";